"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _merge = _interopRequireDefault(require("lodash/merge"));
var _theme = _interopRequireDefault(require("@chakra-ui/theme"));
var _themeTools = require("@chakra-ui/theme-tools");
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var filledStyle = function filledStyle(props) {
  var colorScheme = props.colorScheme,
    hasStripe = props.hasStripe,
    isIndeterminate = props.isIndeterminate,
    theme = props.theme;
  var bgColor = colorScheme === 'gray' ? "".concat(colorScheme, ".dark") : "".concat(colorScheme, ".default");
  var gradient = "linear-gradient(\n      to right,\n      transparent 0%,\n      ".concat((0, _themeTools.getColor)(theme, bgColor), " 50%,\n      transparent 100%\n    )");
  var addStripe = !isIndeterminate && hasStripe;
  return _objectSpread(_objectSpread({}, addStripe && (0, _themeTools.generateStripe)()), isIndeterminate ? {
    bgImage: gradient
  } : {
    bgColor: bgColor
  });
};
var variantOutlined = function variantOutlined(props) {
  var colors = props.theme.colors;
  return {
    track: {
      bg: 'transparent',
      borderWidth: '1px',
      borderColor: colors.gray['200']
    }
  };
};
var variantSolid = function variantSolid(props) {
  var colors = props.theme.colors;
  return {
    track: {
      bg: colors.gray['100']
    }
  };
};
var variants = {
  outlined: variantOutlined,
  solid: variantSolid
};
var sizes = {
  xl: {
    track: {
      height: 10
    }
  },
  lg: {
    track: {
      height: 6
    }
  },
  md: {
    track: {
      height: 4
    }
  },
  sm: {
    track: {
      height: 2
    }
  },
  xs: {
    track: {
      height: 1
    }
  }
};
var defaultProps = {
  size: 'lg',
  colorScheme: 'primary',
  variant: 'solid'
};
var overrides = {
  defaultProps: defaultProps,
  variants: variants,
  sizes: sizes,
  baseStyle: function baseStyle(props) {
    var isRounded = props.sx.isRounded;
    return (0, _merge["default"])(_theme["default"].components.Progress.baseStyle(props), {
      filledTrack: _objectSpread({
        borderRightRadius: isRounded ? 'none' : 'base'
      }, filledStyle(props)),
      track: {
        borderRightRadius: isRounded ? 'full' : 'base',
        borderLeftRadius: isRounded ? 'full' : 'base'
      }
    });
  }
};
var _default = exports["default"] = _objectSpread(_objectSpread({}, _theme["default"].components.Progress), overrides);